import type { KpiAxisConfiguration } from 'components/molecules/PackArchitecture/kpiAxisConfiguration.utils';
import type { KpiAxisControlsMeta } from 'components/molecules/PackArchitecture/kpiAxisControlsMeta.types';
import { PPA_KPI_AXIS_BINNING_CUSTOM, PPA_KPI_AXIS_BINNING_UNIFORM } from 'constants/ppaTestIds';

type BinningToggleProps = {
    uniformLabel: string;
    customLabel: string;
    value: KpiAxisConfiguration['binningMethod'];
    onChange: (value: KpiAxisConfiguration['binningMethod']) => void;
};

const BINNING_TOGGLE_SELECTED_CLASS = 'bg-bgBackground text-purpleFontSelected font-medium';
const BINNING_TOGGLE_UNSELECTED_CLASS = 'bg-white text-blackTransparent88 font-normal';

const BinningToggle = ({ uniformLabel, customLabel, value, onChange }: BinningToggleProps) => (
    <div className="inline-flex h-8 w-[380px] shrink-0 overflow-hidden rounded-lg border border-borderGreyAl1">
        <button
            type="button"
            className={`h-8 flex-1 px-[15px] text-sm ${
                value === 'uniform' ? BINNING_TOGGLE_SELECTED_CLASS : BINNING_TOGGLE_UNSELECTED_CLASS
            }`}
            onClick={() => onChange('uniform')}
            data-testid={PPA_KPI_AXIS_BINNING_UNIFORM}
        >
            {uniformLabel}
        </button>
        <div className="w-px shrink-0 self-stretch bg-borderGreyAl1" />
        <button
            type="button"
            className={`h-8 flex-1 px-[15px] text-sm ${
                value === 'custom' ? BINNING_TOGGLE_SELECTED_CLASS : BINNING_TOGGLE_UNSELECTED_CLASS
            }`}
            onClick={() => onChange('custom')}
            data-testid={PPA_KPI_AXIS_BINNING_CUSTOM}
        >
            {customLabel}
        </button>
    </div>
);

type KpiAxisConfigurationBinsFieldProps = {
    controlsMeta: KpiAxisControlsMeta['bins'];
    value: KpiAxisConfiguration['binningMethod'];
    onChange: (value: KpiAxisConfiguration['binningMethod']) => void;
};

const KpiAxisConfigurationBinsField = ({ controlsMeta, value, onChange }: KpiAxisConfigurationBinsFieldProps) => (
    <div className="flex items-start gap-4">
        <p className="m-0 text-base font-medium leading-6 text-blackTitle">{controlsMeta.label}</p>
        <div className="min-w-0 flex-1">
            <BinningToggle
                uniformLabel={controlsMeta.uniform.label}
                customLabel={controlsMeta.custom.label}
                value={value}
                onChange={onChange}
            />
        </div>
    </div>
);

export default KpiAxisConfigurationBinsField;
